import { 
  ApplicationConfig, 
  provideBrowserGlobalErrorListeners, 
  provideZonelessChangeDetection, 
  isDevMode,
  provideAppInitializer,
  inject,
  InjectionToken
} from '@angular/core';
import { provideRouter, RouteReuseStrategy, withViewTransitions } from '@angular/router';
import { routes } from './app.routes';
import { provideServiceWorker } from '@angular/service-worker';
import { AUTH_SERVICE } from './services/auth.service';
import { SupabaseAuthService } from './services/supabase-auth.service';
import { provideHttpClient, withXhr } from '@angular/common/http';
import { provideTranslateService } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";
import { provideNativeDateAdapter } from '@angular/material/core';
import { ConfigService } from './services/config.service';
import { createClient, SupabaseClient } from '@supabase/supabase-js';
import { environment } from '../environments/environment';
import { DATABASE_SERVICE } from './services/database.service';
import { SupabaseDatabaseService } from './services/supabase-database.service';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { CustomRouteReuseStrategy } from './util/custom-route-reuse-strategy';
import { BackButtonService } from './services/back-button.service';

export const SUPABASE = new InjectionToken<SupabaseClient>('Supabase connection');
const supabaseConnection = createClient(environment.SUPABASE_URL, environment.SUPABASE_KEY);

const intializeAppFn = () => {  
  const configService = inject(ConfigService);
  console.log("Initializing app");
  
  const backService = inject(BackButtonService);
  backService.initHomeBackHandler();

  return configService.init();

};

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes, withViewTransitions()),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
    // provideServiceWorker('ngsw-worker.js', {
    //   enabled: true,
    //   registrationStrategy: 'registerWhenStable:30000'
    // }),
    provideHttpClient(withXhr()),    
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: './i18n/',
        suffix: `.json?v=${environment.VERSION}`
      }),
      fallbackLang: 'en',
      lang: 'en'
    }),
    provideNativeDateAdapter(),
    provideAppInitializer(intializeAppFn),
    { provide: SUPABASE, useValue: supabaseConnection },
    { provide: AUTH_SERVICE, useClass: SupabaseAuthService },
    { provide: DATABASE_SERVICE, useClass: SupabaseDatabaseService },
    {provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: {
        verticalPosition: 'top',
        horizontalPosition: 'center',
        duration: 3000
    }},
    { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy }
  ]
};
